import { IconButton, Menu, MenuItem } from '@mui/material';
import { useAuthContext } from 'context/AuthProvider';
import { logoutUser } from 'apiCalls/apiCalls';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SentimentSatisfiedAltRoundedIcon from '@mui/icons-material/SentimentSatisfiedAltRounded';

export const UserManagement = () => {
    const [isAuthenticated, setIsAuthenticated] = useAuthContext();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const closeAccountMenu = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logoutUser();
        setIsAuthenticated(false);
        navigate('/');
    };

    const handleOpenSettings = () => {
        navigate('/settings');
    };

    return (
        <>
            {isAuthenticated && (
                <>
                    <IconButton
                        onClick={event => {
                            setAnchorEl(event.currentTarget);
                        }}
                        size="small"
                        sx={{ ml: 2, alignSelf: 'center', justifySelf: 'center' }}
                        aria-controls={open ? 'edit-account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <SentimentSatisfiedAltRoundedIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={open}
                        onClose={closeAccountMenu}
                        onClick={closeAccountMenu}
                        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    >
                        <MenuItem onClick={handleOpenSettings}>Settings</MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
                </>
            )}
        </>
    );
};
